import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormGroupBaseComponent} from "../formgroupbase.component";

export interface JBMCheckGroupItem {
  id: number;
  text: string;
  checked: boolean;
  disabled?: boolean;
}

@Component({
  selector: 'jbm-check-group',
  templateUrl: './JBMCheckGroup.component.html',
  styleUrls: ['./JBMCheckGroup.component.scss']
})
export class JBMCheckGroupComponent extends FormGroupBaseComponent implements OnInit {

  @Input() items: JBMCheckGroupItem[] = [];
  @Output() onItemChange = new EventEmitter<JBMCheckGroupItem>();
  @Output() onItemsChange = new EventEmitter<number[]>();

  private propagateChange: any = () => {};

  ngOnInit(): void {
    super.ngOnInit();
    if (this.items == undefined) this.items = [];
  }
  toggle(item: JBMCheckGroupItem) {
    if (item.disabled || this.disabled) return;
    item.checked = !item.checked;
    const checkedIds = this.getCheckedIds();
    this.propagateChange(checkedIds);
    this.onItemChange.emit(item);
    this.onItemsChange.emit(checkedIds);
  }
  getCheckedTexts(): string {
    const texts = this.items.filter((i: any) => i.checked).map((i: any) => i.text);
    return texts.length ? texts.join(', ') : this.valueIfEmpty;
  }
  private getCheckedIds(): number[] {
    return this.items.filter((i: any) => i.checked).map((i: any) => i.id);
  }
  override writeValue(ids: number[]) {
    if (ids && this.items) {
      this.items.forEach((item: any) => item.checked = ids.includes(item.id));
    }
  }
  override registerOnChange(fn: any) {
    this.propagateChange = fn;
  }
}
